// Verify Collection By Name
export const GET_COLLECTION_NAME_VERIFY = "GET_COLLECTION_NAME_VERIFY"
export const GET_COLLECTION_NAME_VERIFY_FAIL = "GET_COLLECTION_NAME_VERIFY_FAIL"
export const GET_COLLECTION_NAME_VERIFY_SUCCESS =
  "GET_COLLECTION_NAME_VERIFY_SUCCESS"

// Get Collection ByteCode
export const GET_COLLECTION_BYTECODE = "GET_COLLECTION_BYTECODE"
export const GET_COLLECTION_BYTECODE_FAIL = "GET_COLLECTION_BYTECODE_FAIL"
export const GET_COLLECTION_BYTECODE_SUCCESS = "GET_COLLECTION_BYTECODE_SUCCESS"

// COLLECTIONs
export const GET_COLLECTIONS = "GET_COLLECTIONS"
export const GET_COLLECTIONS_FAIL = "GET_COLLECTIONS_FAIL"
export const GET_COLLECTIONS_SUCCESS = "GET_COLLECTIONS_SUCCESS"

// Add COLLECTION
export const POST_COLLECTION = "POST_COLLECTION"
export const POST_COLLECTION_FAIL = "POST_COLLECTION_FAIL"
export const POST_COLLECTION_SUCCESS = "POST_COLLECTION_SUCCESS"

//add new collection
export const POST_NEW_COLLECTION = "POST_NEW_COLLECTION"
export const POST_NEW_COLLECTION_FAIL = "POST_NEW_COLLECTION_FAIL"
export const POST_NEW_COLLECTION_SUCCESS = "POST_NEW_COLLECTION_SUCCESS"
// Get COLLECTION
export const GET_COLLECTION_BY_ADDRESS = "GET_COLLECTION_BY_ADDRESS"
export const GET_COLLECTION = "GET_COLLECTION"
export const GET_COLLECTION_FAIL = "GET_COLLECTION_FAIL"
export const GET_COLLECTION_SUCCESS = "GET_COLLECTION_SUCCESS"

//collection by email
// Get COLLECTION
export const GET_COLLECTION_BY_EMAIL = "GET_COLLECTION_BY_EMAIL"
// export const GET_COLLECTION = "GET_COLLECTION"
export const GET_COLLECTION_EMAIL_FAIL = "GET_COLLECTION_EMAIL_FAIL"
export const GET_COLLECTION_EMAIL_SUCCESS = "GET_COLLECTION_EMAIL_SUCCESS"

// update COLLECTION
export const PUT_COLLECTION = "PUT_COLLECTION"
export const PUT_COLLECTION_FAIL = "PUT_COLLECTION_FAIL"
export const PUT_COLLECTION_SUCCESS = "PUT_COLLECTION_SUCCESS"

// Delete COLLECTION
export const DELETE_COLLECTION = "DELETE_COLLECTION"
export const DELETE_COLLECTION_FAIL = "DELETE_COLLECTION_FAIL"
export const DELETE_COLLECTION_SUCCESS = "DELETE_COLLECTION_SUCCESS"

export const GET_COLLECTIONS2 = "GET_COLLECTIONS"
export const GET_COLLECTIONS_FAIL2 = "GET_COLLECTIONS_FAIL"
export const GET_COLLECTIONS_SUCCESS2 = "GET_COLLECTIONS_SUCCESS"


export const GET_NEW_COLLECTIONS_BY_EMAIL_START = "GET_NEW_COLLECTIONS_BY_EMAIL"
export const GET_NEW_COLLECTIONS_BY_EMAIL_FAIL = "GET_NEW_COLLECTIONS_BY_EMAIL_FAIL"
export const GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS = "GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS"


// update COLLECTION
export const PUT_NEW_COLLECTION_START = "PUT_NEW_COLLECTION_START"
export const PUT_NEW_COLLECTION_FAIL = "PUT_NEW_COLLECTION_FAIL"
export const PUT_NEW_COLLECTION_SUCCESS = "PUT_NEW_COLLECTION_SUCCESS"

//get collection by id 
export const GET_NEW_COLLECTION_BY_ID_START = "GET_NEW_COLLECTION_BY_ID_START"
export const GET_NEW_COLLECTION_BY_ID_FAIL = "GET_NEW_COLLECTION_BY_ID_FAIL"
export const GET_NEW_COLLECTION_BY_ID_SUCCESS = "GET_NEW_COLLECTION_BY_ID_SUCCESS"

//update collection by id 
export const PUT_NEW_COLLECTION_BY_ID_START = "PUT_NEW_COLLECTION_START"
export const PUT_NEW_COLLECTION_BY_ID_FAIL = "PUT_NEW_COLLECTION_FAIL"
export const PUT_NEW_COLLECTION_BY_ID_SUCCESS = "PUT_NEW_COLLECTION_SUCCESS"

// Delete new COLLECTION
export const DELETE_NEW_COLLECTION_START = "DELETE_NEW_COLLECTION"
export const DELETE_NEW_COLLECTION_FAIL = "DELETE_NEW_COLLECTION_FAIL"
export const DELETE_NEW_COLLECTION_SUCCESS = "DELETE_NEW_COLLECTION_SUCCESS"

// get all new collections
export const GET_ALL_NEW_COLLECTION_START = "GET_ALL_NEW_COLLECTION_START"
export const GET_ALL_NEW_COLLECTION_FAIL = "GET_ALL_NEW_COLLECTION_FAIL"
export const GET_ALL_NEW_COLLECTION_SUCCESS = "GET_ALL_NEW_COLLECTION_SUCCESS"

// get all new collections with filetr
export const GET_ALL_NEW_COLLECTION_WITH_FILTER_START = "GET_ALL_NEW_COLLECTION_WITH_FILTER_START"
export const GET_ALL_NEW_COLLECTION_WITH_FILTER_FAIL = "GET_ALL_NEW_COLLECTION_WITH_FILTER_FAIL"
export const GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS = "GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS"